import React, { FC } from 'react';

import { FormattedMessage } from 'react-intl';

import commonMessages from '~/core/commonMessages';
import { PlayerStatNames } from '~/core/enums';

import { CommonGCGame, TeamGameStat } from '../../types';
import HeaderSection from '../headerSection/HeaderSection';
import { HeaderContainer } from '../shotsOnGoalByPeriod/styles';

import SideBySideStat from './components/sideBySideStat/SideBySideStat';

import { GameStatContainer } from './styles';

type Props = {
    game: CommonGCGame;
    teamGameStats: Array<TeamGameStat>;
};

const StatCategoryTitles = {
    sog: <FormattedMessage {...commonMessages.statsDescriptions.long[PlayerStatNames.shotsOnGoal]} />,
    faceoffWinningPctg: <FormattedMessage {...commonMessages.statsDescriptions.long[PlayerStatNames.faceoffPctg]} />,
    powerPlay: <FormattedMessage {...commonMessages.statsDescriptions.long[PlayerStatNames.powerPlayPctg]} />,
    pim: <FormattedMessage {...commonMessages.statsDescriptions.long[PlayerStatNames.penaltyMinutes]} />,
    hits: <FormattedMessage {...commonMessages.statsDescriptions.long.hits} />,
    blockedShots: <FormattedMessage {...commonMessages.statsDescriptions.long[PlayerStatNames.blockedShots]} />,
    giveaways: <FormattedMessage {...commonMessages.statsDescriptions.long[PlayerStatNames.giveaways]} />,
    takeaways: <FormattedMessage {...commonMessages.statsDescriptions.long[PlayerStatNames.takeaways]} />,
};

const LIMITED_SCORING_GAME_STATS = ['sog', 'powerPlay', 'pim'];

const GameStats: FC<Props> = ({ game, teamGameStats }) => {
    const { awayTeam, homeTeam } = game;

    const gameStats = game.limitedScoring
        ? teamGameStats.filter(({ category }) => LIMITED_SCORING_GAME_STATS.includes(category))
        : teamGameStats;

    return (
        <GameStatContainer>
            <HeaderContainer>
                <HeaderSection
                    awayTeam={awayTeam}
                    homeTeam={homeTeam}
                    headerMessage={
                        <FormattedMessage
                            description="A phrase that describes Game Stats. (Goals, Assists, Points)"
                            defaultMessage="Game Stats"
                        />
                    }
                />
            </HeaderContainer>
            {gameStats
                .filter((stat) => stat.category !== PlayerStatNames.powerPlayPctg)
                .map((stat, i) => (
                    <SideBySideStat
                        game={game}
                        awayValue={stat.awayValue}
                        homeValue={stat.homeValue}
                        title={StatCategoryTitles[stat.category]}
                        isPercentage={stat.category === PlayerStatNames.faceoffWinningPctg}
                        isPowerPlay={stat.category === PlayerStatNames.powerPlay}
                        key={i}
                    />
                ))}
        </GameStatContainer>
    );
};

export default GameStats;
